import React from "react"
import styled from "styled-components"

const ListTable = ({ children, ...props }) => {
    const { data } = props

    return <CustomTable>{children}</CustomTable>
}

const CustomTable = styled.table`
    width: 100%;
    line-height: 1.5;
    border: 1px solid var(--divider-dark);
    border-radius: 8px;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;

    tr:hover {
        td {
            background-color: var(--base-light-color);
        }
    }

    th,
    td {
        border: none;
        border-bottom: 1px solid var(--divider-dark);
        border-right: 1px solid var(--divider-dark);
        padding: 14px 16px;
        vertical-align: middle;
        text-align: left;
        font-size: 16px;

        &.left {
            text-align: left;
        }
        &.right {
            text-align: right;
        }
        &.center {
            text-align: center;
        }
        &.seq {
            font-weight: 400;
            text-align: center;
        }
        &.date {
            font-weight: 400;
        }

        .status {
            font-weight: 400;
            padding: 4px 8px;
            margin: 0 10px 0 8px;
            background-color: var(--highlight-color);

            &.status-1 {
                background-color: var(--sub-color);
            }
            &.status-2 {
                background-color: var(--highlight-color);
            }
            &.status-3 {
                background-color: var(--main-dark-color);
                color: #fff;
            }
            &.status-4 {
                background-color: var(--gray-color);
                color: #fff;
            }
        }
    }

    th {
        color: var(--gray3-color);
        background-color: var(--bg-light);
        text-align: left;
        font-size: 18px;
        padding: 13px 16px;
    }

    th:last-child,
    td:last-child {
        border-right: none;
    }

    tr:last-child > td {
        border-bottom: none;
    }

    .is-hide {
        * {
            color: var(--lightgray-color);
            text-decoration: line-through;
        }

        .status {
            color: var(--lightgray-color) !important;
            background-color: var(--light-color) !important;
        }

        button {
            background-color: var(--light-color);
            border-color: var(--lightgray-color);
        }
    }
`

export default ListTable
